module.exports = __webpack_public_path__ + "static/media/bg.0c5c105f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.jpg
// module id = 666
// module chunks = 0